import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';

/**
 * Pushes authenticated user info (email, name, company) to Crisp chat
 * so support agents can identify who is writing — even if they skip the email input.
 */
export function useCrispIdentify(user, organization) {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] !== organization || $[1] !== user) {
    t0 = () => {
      if (!user || typeof window === "undefined" || !window.$crisp) {
        return;
      }
      const email = user.primaryEmailAddress?.emailAddress;
      if (email) {
        window.$crisp.push(["set", "user:email", [email]]);
      }
      const parts = [user.firstName, user.lastName].filter(Boolean);
      if (parts.length > 0) {
        window.$crisp.push(["set", "user:nickname", [parts.join(" ")]]);
      }
      if (organization?.name) {
        window.$crisp.push(["set", "user:company", [organization.name]]);
      }
    };
    t1 = [user, organization];
    $[0] = organization;
    $[1] = user;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
}